import React, { useState } from "react";
import { useSelector } from "react-redux";

import Logo from "../assets/images/logo.png";
import Facebook from "../assets/images/icons/social/facebook.svg";
import Instagram from "../assets/images/icons/social/Instagram.svg";
import Whatsapp from "../assets/images/icons/social/Whatsapp.svg";
import Telegram from "../assets/images/icons/social/Telegram.svg";
import Twitter from "../assets/images/icons/social/Twitter.svg";

import Age18Plus from "../assets/images/icons/age18-plus.webp";
import LicenseValidation from "../assets/images/license.png";
import AndroidIcon from "../assets/images/icons/android-icon.svg";
import ChevronRight from "../assets/images/icons/chevron-right.svg";
import BottomNav from "./BottomNav";
import { useTranslation } from "react-i18next";

import BankDeposit from "../assets/images/payments/BankDeposit.png";
import Gpay from "../assets/images/payments/Gpay.png";
import Hdfc from "../assets/images/payments/HDFC.png";
import Icici from "../assets/images/payments/ICICI.png";
import Kotak from "../assets/images/payments/Kotak.png";
import MasterCard from "../assets/images/payments/MasterCard.png";
import Neteller from "../assets/images/payments/Neteller.png";
import Phonepe from "../assets/images/payments/Phonepe.png";
import Sbi from "../assets/images/payments/SBI.png";
import Skrill from "../assets/images/payments/Skrill.png";
import Upi from "../assets/images/payments/UPI.png";
import Visa from "../assets/images/payments/Visa.png";
import Worldpay from "../assets/images/payments/WorldPay.png";
import Slider from "react-slick";

const settings = {
  dots: false,
  arrows: true,
  autoplay: true,
  infinite: true,
  speed: 2000,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const Footer = () => {
  const { appDetails } = useSelector((state) => state.app);
  const { t } = useTranslation();

  return (
    <>
      <footer className="footer">
        <div className="footer-links">
          <ul>
            <li>
              <a href="/contactus">Contact Us</a>
            </li>
            <li>
              <a href="/responsiblegame">Responsible Gaming</a>
            </li>
            <li>
              <a href="/terms">Terms and Conditions</a>
            </li>
            <li>
              <a href="/fairplay">Fair Play</a>
            </li>
            <li>
              <a href="/gamesrule">Games Rules</a>
            </li>
            <li>
              <a href="/privacypolicy">Privacy Policy</a>
            </li>
          </ul>
        </div>
        <div className="footer-links">
          <p>Copyright © 2026 Yildiztop, All rights reserved.</p>

          <p>
            You can play only if you are an adult. Gambling can cause
            pathological addiction
          </p>
        </div>

        <div className="footer-section-three">
          <div className="logo footer-links footer-inner-section d-none d-md-block">
            <a href="/home">
              <img src={appDetails?.LOGO_URL} alt="Logo" height={60} />
            </a>
          </div>
          <div className="footer-links footer-inner-section">
            <div className="footer-inner-mob">
              <div>
                <h3>Customer Support</h3>
                <ul className="follow-us">
                  <li>
                    <a
                      href={
                        appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"
                      }
                      target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                    >
                      <img src={Facebook} alt="facebook" />
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        appDetails?.INSTATGRAM != ""
                          ? appDetails?.INSTATGRAM
                          : "#"
                      }
                      target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                    >
                      <img src={Instagram} alt="instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      <img src={Twitter} alt="twitter" />
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        appDetails?.WHATS_APP_URL != ""
                          ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                          : "#"
                      }
                      target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                    >
                      <img src={Whatsapp} alt="whatsapp" />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      <img src={Telegram} alt="telegram" />
                    </a>
                  </li>
                </ul>
              </div>

              <a
                href="https://dl.dropbox.com/scl/fi/nrv7ql0qp6krri389sat7/Yildiztop.apk?rlkey=vwg7g3a4jmnc8ywax3g3xgh5g&st=at6swaof&dl=1"
                download="https://dl.dropbox.com/scl/fi/nrv7ql0qp6krri389sat7/Yildiztop.apk?rlkey=vwg7g3a4jmnc8ywax3g3xgh5g&st=at6swaof&dl=1"
                className="download-apk ms-0"
              >
                <img src={AndroidIcon} alt="android apk" />
                <div className="text">
                  <span>Application</span>
                  <strong>for Android</strong>
                </div>
                <img
                  src={ChevronRight}
                  alt="chevron right"
                  className="arrow ms-auto d-md-none"
                />
              </a>
            </div>

            <div className="footer-inner-mob footer-links d-md-none age-limit">
              18+
            </div>
          </div>
          <div className="footer-links d-md-flex d-none age-limit">18+</div>
        </div>

        <div className="FooterSliderSection ">
          <Slider {...settings}>
            <div className="paymentImg">
              <img src={BankDeposit} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Gpay} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Hdfc} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Icici} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Kotak} alt="" />
            </div>
            <div className="paymentImg">
              <img src={MasterCard} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Neteller} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Phonepe} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Sbi} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Skrill} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Upi} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Visa} alt="" />
            </div>
            <div className="paymentImg">
              <img src={Worldpay} alt="" />
            </div>
          </Slider>
        </div>
      </footer>

      <BottomNav />
    </>
  );
};

export default Footer;
